import { Listing } from "../types/listingTypes";
import { fetchListings } from "./fetchListings";
import { toast } from "sonner";

/**
 * Fetch similar properties based on a reference property
 *
 * @param property The reference property to find similar properties for
 * @param limit The maximum number of similar properties to return (default: 3)
 * @returns Array of similar properties
 */
export const fetchSimilarProperties = async (
  property: Listing,
  limit: number = 3
): Promise<Listing[]> => {
  if (!property) {
    return [];
  }

  try {
    // Get the city from the property address
    let city = "";
    /*
    if (typeof property.address === "string") {
      // Try to extract city from string address
      const parts = property.address.split(",");
      city = parts.length > 1 ? parts[1].trim() : "";
    } else if (
      property.address &&
      typeof property.address === "object" &&
      property.address !== null &&
      "city" in property.address
    ) {
      city = property.address.city || "";
    }
    */

    // Use the property type and city as filters to find similar properties
    const result = await fetchListings({
      propertyType: property.propertyType?.name || "",
      ...(city ? { location: [city] } : {}),
      limit: limit + 1, // Fetch one extra to account for the current property
    });

    // Filter out the current property and limit to requested number
    const properties = result.properties || [];
    const similarProperties = properties
      .filter((p) => p.id !== property.id)
      .slice(0, limit) as Listing[];

    return similarProperties;
  } catch (error) {
    // Don't show error toast to users since this is a supplementary feature
    // that shouldn't disrupt the main experience if it fails
    return [];
  }
};
